import { useSelector } from '@cbridge-utils/react-redux';
import { isStandaloneMarkoutSelector } from '@cbridge-packages/auth';
import { Brand } from '@cbridge-utils/mui-theme';
import { BRANDING, IBranding } from './branding.constant';

/** cAntifraud branding for a standalone-Markout tenant, cBridge otherwise (LB-5777) */
export const useBranding = (): IBranding => {
  const isStandaloneMarkout = useSelector(isStandaloneMarkoutSelector);

  return BRANDING[isStandaloneMarkout ? Brand.CAntifraud : Brand.CBridge];
};
